import { Box, styled } from "@mui/material";

export const WelcomeAndIntructionsPopUpRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "centert",
  padding: "5rem",
  boxSizing: "border-box",
  backdropFilter: "blur(0.5rem)",
  width: "95dvw",
  height: "50dvh",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  margin: "auto",
  background: `rgba(${theme?.palette?.companyColors?.blackRGB}, 0.8)`,
  borderRadius: theme?.borderRadius?.medium,
  overflowY: "auto",
  overflowX: "hidden",
  [theme.breakpoints.up("md")]: {
    "@media (orientation: portrait)": {
      width: "80dvw",
      height: "50dvh",
    },
  },
  [theme.breakpoints.up("lg")]: {
    width: "55dvw",
    height: "45dvh",
    padding: "5rem",
  },
  [theme.breakpoints.up("xl")]: {
    width: "55dvw",
    height: "50dvh",
    padding: "5rem",
  },
  [theme.breakpoints.down("lg")]: {
    "@media (orientation: landscape)": {
      width: "70dvw",
      height: "65dvh",
    },
    "@media (orientation: portrait)": {
      width: "65dvw",
      height: "40dvh",
    },
  },
}));

export const WelcomeAndIntructionsPopUpItem = styled(Box)(({ theme }) => ({
  zIndex: 1,
  maxHeight: "fit-content",
  width: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  flexBasis: "100%",
  gap: "0.25rem",
  textAlign: "center",
  minWidth: "13vw",
  fontSize: "1.2rem",
  [theme.breakpoints.up("md")]: {
    gap: "2rem",
  },
}));
